export default __webpack_public_path__ + "static/media/menu_open.d770870b.svg";